import { AssetDraftProvider } from "../context/AssetDraftContext"
import { ChatHistoryProvider } from "../context/ChatHistoryContext"
import { ChatsListCtxProvider } from "../context/ChatsListContext"
import { FilterProvider } from "../context/ConsistenceFilterContext"
import { NotificationCtxProvider } from "../context/NotificationContext"
import { UserSectionCtxProvider } from "../context/UserSectionContext"
import { UserModel } from "../modules/auth/models/UserModel"
import Layout from "../pages/layout/Layout"
import { PrivateRoutes } from "./PrivateRoutes"
import { PublicRoutes } from "./PublicRoutes"

export default ({ user }: { user?: UserModel }) => {
    return (
    <ChatsListCtxProvider>
        <ChatHistoryProvider>
          <AssetDraftProvider>
            <UserSectionCtxProvider>
              <NotificationCtxProvider>
                <FilterProvider>
                    <Layout>
                      {
                        user ? <PrivateRoutes/> : <PublicRoutes/>
                      }
                    </Layout>
                </FilterProvider>
              </NotificationCtxProvider>
            </UserSectionCtxProvider>
          </AssetDraftProvider>
        </ChatHistoryProvider>
    </ChatsListCtxProvider>
    )
}